import { Locale } from 'generated/gql';

export const localeToIso = (locale: Locale) => {
  if (locale === Locale.EnglishBritish) {
    return 'en-gb';
  }
  return 'nl';
};

export const isoToLocale = (iso: string): Locale => {
  if (iso === 'en-gb') {
    return Locale.EnglishBritish;
  }
  return Locale.Dutch;
};
